/* global axios */
import ApiClient from './ApiClient';

class DailyWorkTasksAPI extends ApiClient {
  constructor() {
    super('daily_tasks', { accountScoped: true });
  }

  getTasks(params = {}) {
    return axios.get(this.url, { params });
  }

  complete(id, { remark, taskTypes } = {}) {
    return axios.patch(`${this.url}/${id}/complete`, { remark, task_types: taskTypes });
  }
}

export const dailyWorkTasksAPI = new DailyWorkTasksAPI();

const settingClient = new ApiClient('daily_task_setting', {
  accountScoped: true,
});

export const dailyWorkSettingAPI = {
  get: () => axios.get(settingClient.url),
  updateSetting: data =>
    axios.patch(settingClient.url, { daily_task_setting: data }),
  segments: () => axios.get(`${settingClient.url}/segments`),
  status: () => axios.get(`${settingClient.url}/status`),
  runAssignment: () => axios.post(`${settingClient.url}/run_assignment`),
  skipAssignment: () => axios.post(`${settingClient.url}/skip_assignment`),
};
